export default __webpack_public_path__ + "assets/img_present_agreement-f0530f1d.png";